import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import MainPage from './pages/MainPage';
import SudokuGame from './pages/SudokuGame';
import DiamondGame from './pages/DiamondGame';
import Game2048 from './pages/Game2048';
import GrapeGame from './pages/GrapeGame';
import JumpGame from './pages/JumpGame';
import SpeedMathGame from './pages/SpeedMathGame';
import WordleGame from './pages/WordleGame';
import './App.css';

function App() {
  const location = useLocation();

  useEffect(() => {
    // 페이지 변경 시 GA4에 페이지 조회 이벤트 전송
    if (window.gtag) {
      window.gtag('config', 'G-QTTYZXZ156', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/sudoku" element={<SudokuGame />} />
        <Route path="/diamond" element={<DiamondGame />} />
        <Route path="/2048" element={<Game2048 />} />
        <Route path="/grape" element={<GrapeGame />} />
        <Route path="/jump" element={<JumpGame />} />
        <Route path="/speed-math" element={<SpeedMathGame />} />
        <Route path="/wordle" element={<WordleGame />} />
      </Routes>
    </div>
  );
}

export default App;
